module.exports = __webpack_public_path__ + "img/contentImg8.7606af3.png";